<div class="row seminar-refresh-row" *ngIf="jobId">
  <button
    type="button"
    class="seminar-refresh-btn"
    (click)="refresh()"
    [disabled]="isRefreshing"
  >
    <span class="seminar-refresh-btn__icon">
      <svg>
        <use xlink:href="/assets/icons/icn_refresh.svg#refresh"></use>
      </svg>
    </span>
    <span>現在数を取得する</span>
  </button>
</div>

<div class="row">
  <div class="row__column">
    <ag-dynamic-form
      class="row__head-form"
      [metadata]="headMeta"
      [model]="dynamicFormModel"
    ></ag-dynamic-form>
  </div>
</div>

<div class="row">
  <div class="row__column">
    <div class="bulk-text-area">
      <textarea
        id="bulkTextInput"
        class="bulk-text-area__input"
        [(ngModel)]="bulkScheduleInput"
        rows="15"
        placeholder="2026/01/01 14:00~15:00
2026/01/02 10:00~11:30"
      ></textarea>
      <div class="bulk-text-area__error" *ngIf="bulkTextErrors.length">
        <p *ngFor="let error of bulkTextErrors">{{ error }}</p>
      </div>
      <div class="bulk-text-area__actions">
        <button type="button" (click)="applyBulkTextToSchedule()">
          日程一覧を更新する
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="row__column">
    <table class="job-setting-mail-table">
      <thead>
        <tr>
          <th class="no small-col">No.</th>
          <th class="event-date-at wide-col">開催日時</th>
          <th class="capacity small-col">動員枠</th>
          <th class="current small-col">現在</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let setting of schedule; index as i">
          <tr>
            <td class="no small-col">
              {{ i + 1 }}
              <br />
              <input
                class="btn btn--small btn--white btn--outline-gray btn--display-inline"
                type="button"
                value="削除"
                (click)="confirmReset(i, setting.reservationCount)"
              />
            </td>
            <td class="event-date-at wide-col">
              <input
                type="date"
                class="event-data-at margin-left margin-right"
                [disabled]="setting.id ? true : false"
                [(ngModel)]="setting.eventDateAt"
                [min]="minDate"
              />
              <input
                type="time"
                class="event-data-time-from margin-right"
                [(ngModel)]="setting.eventDateTimeFrom"
                (change)="onConfirmChange($event, 'eventDateTimeFrom', i)"
              />〜
              <input
                type="time"
                class="event-data-time-to margin-left"
                [(ngModel)]="setting.eventDateTimeTo"
                (change)="onConfirmChange($event, 'eventDateTimeTo', i)"
              />
              <div
                class="job-setting-mail-table__error"
                *ngFor="let error of getRowFieldErrors(i, 'date')"
              >
                {{ error.message }}
              </div>
            </td>
            <td class="capacity small-col">
              <input
                type="number"
                [(ngModel)]="setting.capacity"
                (input)="onCapacityChange($event, i)"
                min="1"
              />
              <div
                class="job-setting-mail-table__error"
                *ngFor="let error of getRowFieldErrors(i, 'capacity')"
              >
                {{ error.message }}
              </div>
            </td>
            <td class="current small-col">
              {{ setting.reservationCount || 0 }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div class="footer">
  <div class="footer__container">
    <button class="footer__btn footer__btn--blue" (click)="save()">
      更新
    </button>
  </div>
</div>
